import { ApplicationRef, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

/** This services allows downloads to be initiated on the client. */
@Injectable()
export class FileDownloadService {

  /** renderer for this sevice not associated to any element */
  private renderer: Renderer2;

  constructor(private appRef: ApplicationRef, rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * starts download of file on the client
   */
  startBlobDownload(fileName: string, blob: Blob): void {
    if (!blob || !fileName) {
      return;
    }
    this.downloader(fileName, blob);
  }

  /** Starts download of raw data on the client. */
  startRawDownload(fileName: string, data: any, mimeType: string): void {
    const blob = new Blob([data], { type: mimeType });
    this.downloader(fileName, blob);
  }

  /** Executes downloads by clicking a hidden element. */
  private downloader(fileName: string, blob: Blob): void {
    const appElem: HTMLElement = this.appRef.components[0].location.nativeElement;

    const containerElem = this.renderer.createElement('div');
    this.renderer.setAttribute(containerElem, 'data-tap-disabled', 'true');
    this.renderer.setStyle(containerElem, 'display', 'none');

    const linkElem = this.renderer.createElement('a');
    this.renderer.setAttribute(linkElem, 'target', '_blank');
    this.renderer.setAttribute(linkElem, 'href', URL.createObjectURL(blob));
    this.renderer.setAttribute(linkElem, 'download', fileName);
    this.renderer.appendChild(containerElem, linkElem);
    this.renderer.appendChild(appElem, containerElem);

    setTimeout(() => {
      linkElem.click();
      this.renderer.removeChild(appElem, containerElem);
    });
  }
}
